var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "grid-view",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title || _vm.$t("CargoMsg.Cargo_ChooseEdiTemplate"),
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        width: "500px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "1" },
              on: { click: _vm.onSelect }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Select")))]
          )
        ],
        1
      ),
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "show-side-bar": false
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }